import { createScenario } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/scenarios';
import { toggleDialogVisibility } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/scenarios/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	createScenario,
	toggleDialogVisibility,
};
